<template>
  <div class="gs-sk" :class="variant ? 'is-' + variant : ''" aria-hidden="true">
    <i v-for="n in count" :key="n" class="gs-sk-bar" :style="{ width: widths[(n - 1) % widths.length] }"></i>
  </div>
</template>

<script>
export default {
  name: 'GsSkeleton',
  props: {
    rows: { type: Number, default: 4 },
    variant: { type: String, default: '' }
  },
  computed: {
    count() {
      return this.variant === 'banner' || this.variant === 'map' ? 1 : this.rows
    },
    widths() {
      return ['100%', '72%', '88%', '54%']
    }
  }
}
</script>

<style scoped>
.gs-sk {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 0;
}
.gs-sk-bar {
  display: block;
  height: 16px;
  border-radius: 6px;
  background: linear-gradient(90deg, #e7eef8 25%, #f8fbff 37%, #e7eef8 63%);
  background-size: 400% 100%;
  animation: gs-sk 1.15s ease infinite;
}
.gs-sk.is-banner .gs-sk-bar {
  height: 280px;
  width: 100%;
}
.gs-sk.is-map .gs-sk-bar {
  height: 320px;
  width: 100%;
}
.gs-sk.is-card .gs-sk-bar {
  height: 86px;
  width: 100%;
}
@keyframes gs-sk {
  0% { background-position: 100% 0; }
  100% { background-position: 0 0; }
}
</style>
